<template>
    <Schedule
      :id="id"
      :fields="fields"
      :data="data"
      :code="code"
      :config="config"
      :months="undefined"
      :tournDates="tournDates"
      :newReports="newReports"
    />
</template>

<script>
import { Schedule } from "@ocs-software/vue-ocs";
export default {
  name: "First level Schedule Table",
  props: ["id", "fields", "data", "code", "search", "months", "tournDates" , "newReports", "config"],
  components: {
    Schedule
  },
  filters: {
    base: function(value) {
      return btoa(value);
    }
  },
  methods: {
    rowClass(item, type) {
      if (!item || type !== 'row') return
      if (this.code === item.code) return 'live'
    }
  }
};
</script>

<style scoped>
.cancelled {
  background-color: #C8112E;
  color: #fff;
  padding: 5px;
  font-size: 15px;
  position: relative;
  top: -2px;
}
::v-deep .dropleft .dropdown-toggle::before {
  display: none;
}
.activeTournament {
  height: 67px;
  background: #ec0c1e;
  position: absolute;
  left: 70px;
  margin-top: -22px;
  width: 5px;
}
.major {
  color: #3E3E3E!important;
  font-weight: bold!important;
}
.major > a {
  color: #3E3E3E!important;
  font-weight: bold!important;
}
li{
  list-style: none;
}
.nav-link {
  color: #222629;
}
::v-deep th {
  position: sticky;
  top: 0;
  background-color: #263056;
  z-index: 111;
}

::v-deep .live{
  color: #000;
  background-color: #ca8383 !important;
}
::v-deep .live>td>li>a{
  color: #000;
}
::v-deep a.nav-link {
  color: #000;
}
::v-deep .live>td>ul>div>button{
  border: 0;
}
@media only screen and (max-width: 990px) {
  .activeTournament {
    height: 67px;
    background: #ec0c1e;
    position: absolute;
    left: 19px;
    margin-top: -22px;
    width: 5px;
  }
}
@media only screen and (max-width: 768px) {
  .activeTournament {
    display: none;
  }
  td.scheduleNav > li > a {
    font-size: 9pt;
  }
  ::v-deep td.scheduleNav {
    font-size: 9pt!important;
  }
  ::v-deep .btn {
    background-color: #EB0A1E;
    border-color: white;
    font-size: 9pt;
    border-radius: 0;
    width: 100%;
  }
}
</style>
